import { VOICE_OF_CUSTOMER_FLAG_KEY } from '@aica/core';
import { LockedDemoBanner } from '@/components/ui/LockedDemoBanner';
import { useVoiceDemoOnlyAnswered } from './useVoiceDemoOnly';
import type { VoiceAudience, VoiceSearch } from './voice-search';

/** The banner over the section — once the open tab's current read has answered with the demo (`useVoiceDemoOnlyAnswered`). */
export function VoiceDemoBanner({
  search,
  onSearchChange,
  audience,
}: {
  search: VoiceSearch;
  onSearchChange: (patch: Partial<VoiceSearch>) => void;
  audience: VoiceAudience;
}) {
  if (!useVoiceDemoOnlyAnswered(search, onSearchChange, audience)) return null;
  return (
    <div className="mb-4">
      <LockedDemoBanner flag={VOICE_OF_CUSTOMER_FLAG_KEY} />
    </div>
  );
}
